declare const environment: string;
const _serverUrl = environment === 'prod' ? 'https://mopsfunctions.azurewebsites.net/' : (environment === 'test' ? 'https://mopsfunctionstest.azurewebsites.net/' : 'http://localhost:7071/')
const _signalRUrl = environment === 'prod' ? 'https://mopssignalr.azurewebsites.net/SignalRRelay' : (environment === 'test' ? 'https://mops-it-test-signalr-linux-a7erd0f4fuezaeby.westeurope-01.azurewebsites.net/SignalRRelay' : 'http://localhost:5000/SignalRRelay')
const _clientUrl = environment === 'prod' ? 'https://mops-it-client.azurewebsites.net/' : (environment === 'test' ? 'https://red-grass-050456603.4.azurestaticapps.net/' : 'https://localhost:8888/')
export { _serverUrl as serverUrl };
export { _signalRUrl as signalRUrl };
export { _clientUrl as clientUrl };
// the test system is closed, its backend rejects registrations without the code
export const registrationCodeRequired = environment === 'test';

